var map = {
	"./BannerConversa": 23,
	"./BannerConversa.png": 23,
	"./BannerConversaTolas": 24,
	"./BannerConversaTolas.png": 24,
	"./bannerConversaModal": 25,
	"./bannerConversaModal.png": 25,
	"./ico_conversa_close": 26,
	"./ico_conversa_close.png": 26,
	"./ico_conversa_float": 27,
	"./ico_conversa_float.png": 27,
	"./iconWarning": 28,
	"./iconWarning.png": 28,
	"./logoConversa": 29,
	"./logoConversa.png": 29,
	"./logoConversaIco": 30,
	"./logoConversaIco.png": 30,
	"./logo_Conversa_Color": 31,
	"./logo_Conversa_Color.png": 31,
	"./logo_Conversa_Color_Part": 32,
	"./logo_Conversa_Color_Part.png": 32
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69;